<template>
  <div class="news">
    <fixed-tab>
      <van-tabs slot="content" :line-width="16" :line-height="2" @click="onTabChange">
        <template v-for="(item, index) in classify">
          <van-tab :key="index" :title="item.name"></van-tab>
        </template>
      </van-tabs>
    </fixed-tab>
    <Empty v-if="!newsList.length" :empty_type="{ name: '暂无资讯' }"></Empty>
    <List
      v-if="showList"
      ref="list"
      url="/api/app/information/index"
      method="post"
      :params="params"
      :on-getdata="onGetdata"
      :showText="newsList.length > 0"
    >
      <news-item slot="item" :newsList="newsList"></news-item>
      <!-- <ul class="news-content" >
        <li v-for="(item, index) in newsList" :key="index" @click="onItem(item)">
          <img :src="item.thumb_img" />
          <div>
            <p class="name">{{ item.title }}</p>
            <p class="desc">{{ item.description }}</p>
            <div>
              <p class="number">{{ item.click_rate }}</p>
              <p class="time">{{ item.created_at | fomartTime("yyyy/MM/dd hh:mm") }}</p>
            </div>
          </div>
        </li>
      </ul>-->
    </List>
  </div>
</template>

<script>
import Empty from "@/components/Empty";
import List from "@/components/List";
import newsItem from "./NewsItem";
export default {
  name: "news",
  components: {
    Empty,
    List,
    newsItem
  },
  data() {
    return {
      classify: [], // 资讯类别
      newsList: [], // 资讯列表
      params: {
        classify_id: ""
      },
      showList: false // 是否展示列表，在请求到分类之前不展示
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.requestClassify();
  },
  methods: {
    // on event
    onTabChange(index) {
      this.params.classify_id = this.classify[index].id;
      this.$refs.list.reset();
    },
    onGetdata(data) {
      this.newsList = data;
    },
    // request
    requestClassify() {
      this.$http.get("/api/app/information/classify").then(data => {
        // this.classify.unshift({
        //   id: 0,
        //   name: "全部",
        //   parent_id: 0
        // });

        // type为教师端
        let itemId = this.type ? [4, 7, 5, 2] : [5, 2];

        this.classify = data.filter((item) => itemId.includes(item.id));

        if (this.classify.length) {
          this.params.classify_id = this.classify[0].id;
        }
        this.showList = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.news {
  @extend %default-bg;
  /deep/ .van-tab {
    padding: 0 20px;
  }
  background-color: #fff;
}
</style>
